import ConfigField from '../ConfigField';
import { NODE_CONFIG_FIELDS } from '../../../constants';

export default function TelegramConfig({ data, onChange }) {
  const fields = NODE_CONFIG_FIELDS.action_telegram;

  return (
    <div className="space-y-4">
      {fields.map((field) => (
        <div key={field.key}>
          <label className="block text-xs font-medium text-gray-600 mb-1.5">{field.label}</label>
          <ConfigField field={field} value={data[field.key]} onChange={(v) => onChange(field.key, v)} allData={data} onChangeField={onChange} />
        </div>
      ))}
    </div>
  );
}
